export const classes = {
  paper: 'bg-gradient-to-br from-grey-100/60 via-blue-100/20 to-blue-200/30',
};

export const styles = {
  drawer: {
    zIndex: 1300, // Match MUI's modal layer so stacking follows mount order
    '.MuiDrawer-paper': {
      backgroundColor: 'hsla(0,0%,97%,0.6)',
      backdropFilter: 'blur(15px)',
      boxShadow: '2px 0px 40px hsla(0 0% 10% / 0.15)',
    },
  },
  backdrop: {
    backgroundColor: 'hsla(0,0%,0%,0.2)',
  },
  glassDrawer: {
    zIndex: 1300, // Match MUI's modal layer so stacking follows mount order
    '& .MuiDrawer-paper': {
      top: '10px',
      left: '10px',
      height: 'calc(100% - 20px)',
      borderRadius: '18px',
      border: '1px solid rgba(255,255,255,0.72)',
      backgroundColor: 'rgba(255,255,255,0.86)',
      backdropFilter: 'blur(40px)',
      boxShadow:
        '42px 0 110px -34px rgba(0,0,0,.5), 0 32px 84px -28px rgba(70,60,90,.30), 0 2px 10px rgba(70,60,90,.06)',
      overflow: 'hidden',
    },
    // `.dark` lives on <html>; scope the override to this drawer's portaled paper
    '.dark & .MuiDrawer-paper': {
      border: '1px solid rgba(255,255,255,0.14)',
      backgroundColor: 'rgba(33,29,47,0.82)',
      boxShadow:
        '42px 0 110px -34px rgba(0,0,0,.5), 0 36px 90px -28px rgba(0,0,0,.62), 0 2px 10px rgba(0,0,0,.4)',
    },
  },
  glassBackdrop: {
    background:
      'linear-gradient(90deg, rgba(22,18,28,0.07), rgba(22,18,28,0.4))',
    backdropFilter: 'blur(2px)',
  },
};
